import { render } from "./AllEvents.vue?vue&type=template&id=d67c6534&scoped=true"
import script from "./AllEvents.vue?vue&type=script&lang=js"
export * from "./AllEvents.vue?vue&type=script&lang=js"

import "./AllEvents.vue?vue&type=style&index=0&id=d67c6534&scoped=true&lang=css"

import exportComponent from "D:\\Front-end\\Beetronix\\alradwan-frontend\\vue-1\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d67c6534"]])

export default __exports__